import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: "",
  name: "",
  id: "",
};
export const userSlice = createSlice({
  name: "user_info",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.username = action.payload.username;
      state.name = action.payload.name;
      state.id = action.payload.id;
    },
    unSetUserInfo: (state, action) => {
      state.username = action.payload.username;
      state.name = action.payload.name;
      state.id = action.payload.id;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserInfo, unSetUserInfo } = userSlice.actions;

export default userSlice.reducer;
